import Hero from '../../components/Hero';
import NavigationBar from '../../components/NavigationBar';
import Footer from '../../components/Footer';
import Partners from '../../components/Partners';
import CookieBanner from '../../components/CookieBaner';
import Boats from '../../components/Content/Boats';
import PriceTable from '../../components/Content/PriceTable';
import Gallery from '../../components/Gallery';
import { boatsImages } from "../../components/Content/Boats/images/boatsImages"
import { Container } from '../../components/Content/styled';
import BoatsHero480 from "./images/electric-boats480p.webp";
import BoatsHero768 from "./images/electric-boats768p.webp";
import BoatsHero1080 from "./images/electric-boats.webp";
import BoatsHero1440 from "./images/electric-boats.webp";
import GoogleMap from '../../components/Content/GoogleMap';
import Address from '../../components/Content/Address';
import FundingBanner from '../../components/FundingInfo/FundingBanner';
import FundingInfo from '../../components/FundingInfo';

function BoatsPage() {
    return (
        <>
            <NavigationBar variant="boats" />
            <main>
                <Hero
                    variant="boats"
                    images={{
                        480: BoatsHero480,
                        768: BoatsHero768,
                        1080: BoatsHero1080,
                        1440: BoatsHero1440,
                    }}
                    bottomContent={<FundingBanner />}
                />
                <Container>
                    <Boats />
                    <PriceTable variant="boats" />
                    <Address variant="boats" />
                    <GoogleMap variant="boats" />
                </Container>
                <Gallery images={boatsImages} variant="boats" />
                <FundingInfo />
                <Partners />
            </main>
            <Footer />
            <CookieBanner />
        </>
    );
}
export default BoatsPage;